import { PusherEventName } from 'anchor-scout-common/types';
import { useBusinessChannelEvent } from '~/pusher';
// WHY: a sent or approved proposal reaches the list live, the empty dashboard included.
export function useProposalsLiveRefresh(refresh) {
    useBusinessChannelEvent({
        source: 'scout',
        eventName: PusherEventName.RelationshipCreatedFromScheduledDraft,
        callback: ()=>refresh()
    });
    useBusinessChannelEvent({
        source: 'scout',
        eventName: PusherEventName.RelationshipApproved,
        callback: ()=>refresh()
    });
}
